import React from 'react';
import gsap from 'gsap';

import css from './universe.module.scss';

interface Props {
  ref: React.Ref<HTMLDivElement>;
  star1Ref: React.Ref<HTMLDivElement>;
  star2Ref: React.Ref<HTMLDivElement>;
  star3Ref: React.Ref<HTMLDivElement>;
  star4Ref: React.Ref<HTMLDivElement>;
  star5Ref: React.Ref<HTMLDivElement>;
  star6Ref: React.Ref<HTMLDivElement>;
  star7Ref: React.Ref<HTMLDivElement>;
  circleRef: React.Ref<HTMLDivElement>;
}

export const Universe: React.FC<Props> = ({
  ref,
  star1Ref,
  star2Ref,
  star3Ref,
  star4Ref,
  star5Ref,
  star6Ref,
  star7Ref,
  circleRef,
}) => {
  return (
    <div className={css.universe} ref={ref}>
      <div>
        <div className={css.star} ref={star1Ref} />
        <div className={css.star} ref={star2Ref} />
        <div className={css.star} ref={star3Ref} />
        <div className={css.star} ref={star4Ref} />
        <div className={css.star} ref={star5Ref} />
        <div className={css.star} ref={star6Ref} />
        <div className={css.star} ref={star7Ref} />
      </div>
      <div className={css.circle} ref={circleRef} />
    </div>
  );
};
